let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bfeTU")).then(() => parcelRequire('dyPRF'));